// extracted by mini-css-extract-plugin
export default {"Loader":"Spinner_Loader__cumxg","load2":"Spinner_load2__PSdaJ"};